import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Download, Package, FileText, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const META = {
  aab: { label: 'Pacote Android (.aab)', icon: Package, desc: 'App Bundle assinado para envio à Google Play Store' },
  privacy: { label: 'Política de Privacidade', icon: FileText, desc: 'Página HTML exigida pela Google Play' },
  s24: { label: 'Formulário S-24 Editável', icon: FileText, desc: 'Recibo (S-24-T) em PDF com campos preenchíveis' },
};

function formatSize(bytes) {
  if (bytes > 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / 1024).toFixed(1)} KB`;
}

export const ReleaseDownloads = () => {
  const [files, setFiles] = useState([]);
  const [downloading, setDownloading] = useState(null);

  useEffect(() => {
    axios.get(`${API}/releases/list`)
      .then((res) => setFiles(res.data.files || []))
      .catch(() => {});
  }, []);

  const handleDownload = async (file) => {
    setDownloading(file.key);
    try {
      const res = await axios.get(`${API}/releases/download/${file.key}`, { responseType: 'blob' });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success(`${file.filename} baixado!`);
    } catch (e) {
      toast.error('Erro ao baixar o arquivo.');
    } finally {
      setDownloading(null);
    }
  };

  if (files.length === 0) return null;

  return (
    <Card className="mb-6" data-testid="release-downloads-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Package className="w-5 h-5" />
          Arquivos para Download
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid gap-3 sm:grid-cols-2">
          {files.map((file) => {
            const meta = META[file.key] || { label: file.filename, icon: FileText, desc: '' };
            const Icon = meta.icon;
            return (
              <div key={file.key} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-4">
                <div className="flex items-start gap-3 min-w-0">
                  <Icon className="w-5 h-5 mt-0.5 text-slate-600 shrink-0" />
                  <div className="min-w-0">
                    <p className="font-medium text-sm text-slate-900 truncate">{meta.label}</p>
                    <p className="text-xs text-slate-500">{meta.desc}</p>
                    <p className="text-xs text-slate-400 mt-1">{file.filename} · {formatSize(file.size_bytes)}</p>
                  </div>
                </div>
                <Button
                  size="sm"
                  variant="outline"
                  className="gap-2 shrink-0"
                  disabled={downloading === file.key}
                  onClick={() => handleDownload(file)}
                  data-testid={`download-release-${file.key}-btn`}
                >
                  {downloading === file.key ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
                  Baixar
                </Button>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};
